import { useQuery } from '@tanstack/react-query';
import type { KeywordDomains } from '@brand24-original/llm-types';
import { getKeywordDomains } from '../../../../services/monitor/keywords/KeywordsService';
import { GET_KEYWORD_DOMAINS } from '../../../query/keyword/keys';

/**
 * Domeny marek projektu, pobierane osobno od samej listy keywordów — lista jest agregatem po
 * promptach i nie ma powodu przeliczać jej za każdym razem, gdy ktoś doda albo wykluczy domenę.
 */
export const useGetKeywordDomains = (projectId: number | null) => {
  const queryEnabled = !!projectId;

  const { data, isLoading, isError } = useQuery<KeywordDomains[]>({
    queryKey: [GET_KEYWORD_DOMAINS, projectId],
    queryFn: () => getKeywordDomains({ projectId: projectId! }),
    staleTime: 1000 * 60,
    gcTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    enabled: queryEnabled,
  });

  return {
    keywordDomains: queryEnabled ? data ?? [] : [],
    isLoading: queryEnabled ? isLoading : false,
    isError: queryEnabled ? isError : false,
  };
};
